module.exports = __webpack_public_path__ + "static/media/cl.44057a82.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cl.svg
// module id = 2065
// module chunks = 0